/** 默认展示推荐标签数量 */
export const defaultVisibleTagCount = 5;

/** 计算展示推荐标签数量 */
export function calcVisibleTagCount(tagsNode, tagsNodeArr, tagGap = 8) {
  let visibleTagCount = defaultVisibleTagCount;
  let leftWidth = tagsNode?.offsetWidth ?? 0;
  const arr = tagsNodeArr ?? [];
  for (let index = 0; index < arr.length ?? 0; index++) {
    const curWidth = arr[index]?.offsetWidth ?? 0;
    const nextWidth = arr[index + 1]?.offsetWidth ?? 0;
    leftWidth = leftWidth - curWidth - tagGap;
    if (leftWidth - tagGap < nextWidth) {
      visibleTagCount = index + 1;
      break;
    }
  }
  return visibleTagCount;
}
